// Theme toggle component
import { useTheme } from '../../hooks/useTheme';
import { useTranslation } from 'react-i18next';

export default function ThemeToggle() {
  const { theme, setTheme, isDark } = useTheme();
  const { t } = useTranslation();

  const cycleTheme = () => {
    if (theme === 'light') setTheme('dark');
    else if (theme === 'dark') setTheme('system');
    else setTheme('light');
  };

  return (
    <button
      onClick={cycleTheme}
      className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition"
      title={t('theme', 'Tema')}
      aria-label={t('theme', 'Tema')}
    >
      {theme === 'system' ? (
        // Split sun/moon icon for system theme
        <svg className="w-5 h-5" viewBox="0 0 24 24">
          <defs>
            <clipPath id="leftHalf">
              <polygon points="0,0 24,0 0,24" />
            </clipPath>
            <clipPath id="rightHalf">
              <polygon points="24,0 24,24 0,24" />
            </clipPath>
          </defs>
          {/* Sun half (top-left) */}
          <g clipPath="url(#leftHalf)">
            <circle cx="12" cy="12" r="4" fill="#EAB308" />
            <g stroke="#EAB308" strokeWidth="2" strokeLinecap="round">
              <line x1="12" y1="2" x2="12" y2="4" />
              <line x1="12" y1="20" x2="12" y2="22" />
              <line x1="4" y1="12" x2="2" y2="12" />
              <line x1="20" y1="12" x2="22" y2="12" />
              <line x1="6.34" y1="6.34" x2="4.93" y2="4.93" />
              <line x1="17.66" y1="17.66" x2="19.07" y2="19.07" />
              <line x1="6.34" y1="17.66" x2="4.93" y2="19.07" />
              <line x1="17.66" y1="6.34" x2="19.07" y2="4.93" />
            </g>
          </g>
          {/* Moon half (bottom-right) */}
          <g clipPath="url(#rightHalf)">
            <path
              d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"
              fill="#9CA3AF"
              className="dark:fill-yellow-400"
            />
          </g>
          {/* Diagonal divider */}
          <line x1="0" y1="24" x2="24" y2="0" stroke="currentColor" strokeWidth="1.5" className="text-gray-400 dark:text-gray-500" />
        </svg>
      ) : isDark ? (
        // Moon icon
        <svg className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 24 24">
          <path d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" />
        </svg>
      ) : (
        // Sun icon
        <svg className="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.25a.75.75 0 01.75.75v2.25a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zM7.5 12a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM18.894 6.166a.75.75 0 00-1.06-1.06l-1.591 1.59a.75.75 0 101.06 1.061l1.591-1.59zM21.75 12a.75.75 0 01-.75.75h-2.25a.75.75 0 010-1.5H21a.75.75 0 01.75.75zM17.834 18.894a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 10-1.061 1.06l1.59 1.591zM12 18a.75.75 0 01.75.75V21a.75.75 0 01-1.5 0v-2.25A.75.75 0 0112 18zM7.758 17.303a.75.75 0 00-1.061-1.06l-1.591 1.59a.75.75 0 001.06 1.061l1.591-1.59zM6 12a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h2.25A.75.75 0 016 12zM6.697 7.757a.75.75 0 001.06-1.06l-1.59-1.591a.75.75 0 00-1.061 1.06l1.59 1.591z" />
        </svg>
      )}
    </button>
  );
}
